import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hint-section" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "toggle-label" }
const _hoisted_4 = { class: "hint-description" }
const _hoisted_5 = {
  key: 0,
  class: "hint-body"
}
const _hoisted_6 = { class: "chip-input-wrapper" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { VueTagsInput } from '@vojtechlanka/vue-tags-input';
import Field from '@/modules/shared/components/molecules/field/Field.vue';
import TextArea from '@/modules/shared/components/atoms/textArea/TextArea.vue';

interface Props {
  glossary: string[];
  context: string;
}

const MAX_GLOSSARY = 50;
const MAX_TERM_LEN = 80;
const MAX_CONTEXT_LEN = 2000;


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoGenerateHintSection',
  props: {
    glossary: {},
    context: {}
  },
  emits: ["update:glossary", "update:context"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

const expanded = ref<boolean>(props.glossary.length > 0 || props.context.length > 0);

const glossaryDraft = ref<string>('');

const glossaryTags = computed(() => props.glossary.map((text) => ({ text })));
const glossaryCount = computed(() => props.glossary.length);
const contextCount = computed(() => props.context.length);

const glossaryPlaceholder = computed(() => (
  props.glossary.length === 0 ?
    t('video.subtitle.modal.autoGenerate.hint.glossary.placeholder')
    : ''
));

const glossaryValidation = [
  {
    classes: 'ti-invalid',
    rule: (tag: { text: string }) => tag.text.length > MAX_TERM_LEN,
  },
];

function onGlossaryChanged(newTags: Array<{ text: string }>) {
  const accepted = newTags
    .map((tag) => tag.text)
    .filter((text) => text.length > 0 && text.length <= MAX_TERM_LEN)
    .slice(0, MAX_GLOSSARY);
  emit('update:glossary', accepted);
  glossaryDraft.value = '';
}

const contextLocal = computed({
  get: () => props.context,
  set: (value: string) => emit('update:context', value),
});

function counterClass(count: number, max: number): string {
  const pct = count / max;
  if (pct >= 1) return 'counter--red';
  if (pct >= 0.8) return 'counter--amber';
  return 'counter--neutral';
}

function toggle() {
  expanded.value = !expanded.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "hint-toggle",
      "aria-expanded": expanded.value,
      onClick: toggle
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(['fas', expanded.value ? 'fa-chevron-up' : 'fa-chevron-down'])
      }, null, 2),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('video.subtitle.modal.autoGenerate.hint.toggle')), 1)
    ], 8, _hoisted_2),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('video.subtitle.modal.autoGenerate.hint.description')), 1),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(Field, {
            title: _unref(t)('video.subtitle.modal.autoGenerate.hint.glossary.label'),
            helpText: _unref(t)('video.subtitle.modal.autoGenerate.hint.glossary.help'),
            className: "hint-field"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(VueTagsInput), {
                  modelValue: glossaryDraft.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((glossaryDraft).value = $event)),
                  tags: glossaryTags.value,
                  "add-on-key": [13, 188],
                  separators: [','],
                  "max-tags": MAX_GLOSSARY,
                  validation: glossaryValidation,
                  placeholder: glossaryPlaceholder.value,
                  "autocomplete-min-length": 0,
                  autocomplete: "off",
                  onTagsChanged: onGlossaryChanged
                }, null, 8, ["modelValue", "tags", "placeholder"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['counter', counterClass(glossaryCount.value, MAX_GLOSSARY)])
              }, _toDisplayString(_unref(t)('video.subtitle.modal.autoGenerate.hint.glossary.counter', { count: glossaryCount.value })), 3)
            ]),
            _: 1
          }, 8, ["title", "helpText"]),
          _createVNode(Field, {
            title: _unref(t)('video.subtitle.modal.autoGenerate.hint.context.label'),
            helpText: _unref(t)('video.subtitle.modal.autoGenerate.hint.context.help'),
            className: "hint-field"
          }, {
            default: _withCtx(() => [
              _createVNode(TextArea, {
                modelValue: contextLocal.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contextLocal).value = $event)),
                placeholder: _unref(t)('video.subtitle.modal.autoGenerate.hint.context.placeholder'),
                rows: 4,
                maxLength: MAX_CONTEXT_LEN
              }, null, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", {
                class: _normalizeClass(['counter', counterClass(contextCount.value, MAX_CONTEXT_LEN)])
              }, _toDisplayString(_unref(t)('video.subtitle.modal.autoGenerate.hint.context.counter', { count: contextCount.value })), 3)
            ]),
            _: 1
          }, 8, ["title", "helpText"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})